import './inclusao-beneficiario-cancelar-controller';
import './inclusao-beneficiario-consulta-controller';
import './inclusao-beneficiario-nova-inclusao-controller';
